var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-1",attrs:{"width":"100%"}},[_c('v-row',{staticClass:"txtAlgnMid pa-0",attrs:{"no-gutters":""}},[_c('span',[_vm._v("잠시만 기다려 주세요...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }